import { render, staticRenderFns } from "./virtual_production.vue?vue&type=template&id=7aa51c7a&scoped=true"
import script from "./virtual_production.vue?vue&type=script&lang=js"
export * from "./virtual_production.vue?vue&type=script&lang=js"
import style0 from "./virtual_production.vue?vue&type=style&index=0&id=7aa51c7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa51c7a",
  null
  
)

export default component.exports